import videosTemplateTemplate from "/scripts/_partials/videos/templates/videosTemplate.html";
function videosDirective() {
  return {
    restrict: 'A',
    controller: 'VideosCtrl',
    controllerAs: 'videos',
    scope: {
      productId: '@',
      onReceive: '&'
    },
    bindToController: true,
    replace: true,
    templateUrl: videosTemplateTemplate
  };
}
export { videosDirective };